import React from 'react';
import { Card, CardHead, Pill } from '../components/UI';
import s from './Payment.module.css';

const PAYMENT_INVOICES = [
  { inv:'INV-1183', supplier:'Bharat Petro Supplies', amount:'₹18.4 L', bank:'ICICI ****4421', comp:94, compColor:'var(--accent)', by:'R. Kumar (CFO)', status:'ready', statusLabel:'Cleared' },
  { inv:'INV-1181', supplier:'Reliance Trading Co.', amount:'₹42.0 L', bank:'SBI ****7712', comp:89, compColor:'var(--accent)', by:'R. Kumar (CFO)', status:'ready', statusLabel:'Cleared' },
  { inv:'INV-1178', supplier:'SunTech Lubricants', amount:'₹7.5 L', bank:'HDFC ****3310', comp:91, compColor:'var(--accent)', by:'P. Nair (Finance)', status:'ready', statusLabel:'Cleared' },
  { inv:'INV-1177', supplier:'Deccan Petroleum', amount:'₹22.1 L', bank:'Axis ****9902', comp:78, compColor:'var(--warn)', by:'Pending CFO', status:'pending', statusLabel:'Awaiting' },
];

export default function Payment() {
  return (
    <div>
      <div className={s.payRow}>
        <div className={`${s.payBox} ${s.green}`}>
          <div className={s.pval}>₹2.5 Cr</div>
          <div className={s.plbl}>Ready for payment</div>
          <div className={s.pcount}>31 invoices cleared</div>
        </div>
        <div className={`${s.payBox} ${s.yellow}`}>
          <div className={s.pval}>₹40 L</div>
          <div className={s.plbl}>Pending documents</div>
          <div className={s.pcount}>8 invoices on hold</div>
        </div>
        <div className={`${s.payBox} ${s.red}`}>
          <div className={s.pval}>₹18 L</div>
          <div className={s.plbl}>High risk — held</div>
          <div className={s.pcount}>4 invoices flagged</div>
        </div>
      </div>

      <Card>
        <CardHead
          title="Payment-ready invoices"
          action={
            <button className={s.btnPrimary}><i className="ti ti-download" /> Export payment list</button>
          }
        />
        <div className={s.tableWrap}>
          <table className={s.table}>
            <thead>
              <tr><th>Invoice</th><th>Supplier</th><th>Amount</th><th>Bank</th><th>Compliance</th><th>Approved by</th><th>Action</th></tr>
            </thead>
            <tbody>
              {PAYMENT_INVOICES.map(p => (
                <tr key={p.inv}>
                  <td style={{color:'var(--info)'}}>{p.inv}</td>
                  <td>{p.supplier}</td>
                  <td style={{fontWeight:500}}>{p.amount}</td>
                  <td style={{color:'var(--muted)',fontSize:11}}>{p.bank}</td>
                  <td><span style={{color:p.compColor,fontWeight:600}}>{p.comp}/100</span></td>
                  <td style={{fontSize:11,color:'var(--muted)'}}>{p.by}</td>
                  <td><Pill type={p.status}>{p.statusLabel}</Pill></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
